import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Icon / 20x20 / Dark",
		clipPath: "url(#clip0_7548_26699)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M11.6887 1.83788C9.4095 2.43208 7.72729 4.50445 7.72729 6.96972C7.72729 9.8985 10.1015 12.2727 13.0303 12.2727C15.4956 12.2727 17.568 10.5905 18.1622 8.31138C18.2744 8.8567 18.3334 9.42148 18.3334 10C18.3334 14.6024 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6024 1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669C10.5786 1.66669 11.1433 1.72564 11.6887 1.83788Z",
			stroke: "",
			strokeWidth: 1.4,
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7548_26699",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgMoon;
